import { EARNING_RULE_TYPES } from './constants';

export function constructEarningRule(rule, currency = '$') {
  if (!rule) return '';

  switch (rule.type.toString()) {
    case EARNING_RULE_TYPES.ORDER:
      return `Earn ${rule.points} point${
        rule.points === 1 ? '' : 's'
      } for each order`;
    case EARNING_RULE_TYPES.AMOUNT:
      return `Earn ${rule.points} point${
        rule.points === 1 ? '' : 's'
      } for every ${currency}${rule.amount} spent`;
    case EARNING_RULE_TYPES.REFERRAL:
      return `Earn ${rule.points} point${
        rule.points === 1 ? '' : 's'
      } for each referral`;
    case EARNING_RULE_TYPES.SIGN_UP:
      return `Earn ${rule.points} point${
        rule.points === 1 ? '' : 's'
      } for signing up`;
    case EARNING_RULE_TYPES.ITEM_PURCHASED:
      return `Earn ${rule.points} point${
        rule.points === 1 ? '' : 's'
      } for each item purchased`;
    default:
      return '';
  }
}
